import { Dispatch } from 'redux';
import { apiErrorClear } from '../../../../global/ducks/base-api';
import { getCompensationWithHandler } from '../../../../global/ducks/benadmin-api';
import { setEmploymentCompensation } from './employment-compensation-slices';

export function GetEmploymentsAndCompensations(dispatch: Dispatch<any>, employments: any) {
	const employmentComps = [];
	employments?.data?.map(a =>
		dispatch(getCompensationWithHandler(
			a?.employee_guid,
			a?.id,
			(data) => {
				employmentComps.push(
					{
						employment: a,
						compensations: data?.data,
					},
				);
				dispatch(setEmploymentCompensation(employmentComps));
			},			
			() => {
				employmentComps.push(
					{
						employment: a,
						compensations: null,
					},
				);
				dispatch(setEmploymentCompensation(employmentComps));
				dispatch(apiErrorClear());
			},
		)));

}